import { PublicPageZip } from "@/utils/page";
import { JobGetResponse } from "@/types/job";
import Section from "@/components/Section/Section";
import SectionContainer from "@/components/Section/SectionContainer";
import SectionHeader from "@/components/Section/SectionHeader";
// @ts-ignore
import Markdown from "react-markdown";
// @ts-ignore
import remarkGfm from "remark-gfm";

interface Section29Props extends React.HTMLAttributes<HTMLElement> {
  job?: JobGetResponse;
  page: any;
  section: any;
}

const Section29 = ({ job, page, section, ...props }: Section29Props) => {
  return (
    <Section section={section} {...props}>
      <SectionContainer section={section}>
        <SectionHeader section={section} />
        <div className="mx-auto flex flex-col gap-4 lg:w-2/3">
          {section?.TextContent && <Markdown remarkPlugins={[remarkGfm]}>{section?.TextContent}</Markdown>}
        </div>
      </SectionContainer>
    </Section>
  );
};

export default Section29;
